'use strict';

import {Component, Input,OnDestroy} from '@angular/core';

@Component({
    selector: 'spinner',
    standalone: false,
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnDestroy  {
   
    public showSpinner: boolean = false;
    public size: string = '';

    @Input()
    public delay: number = 300;

    /** Full-screen dimmed overlay (page loads). When false, spinner stays within its parent (e.g. sidenav). */
    @Input()
    public overlay: boolean = true;

    @Input()
    public set isRunning(value: boolean) {
        this.showSpinner = !!value;
    }

    get spinnerDiameter(): number {
        if (this.size === 'small') {
            return 60;
        }
        return this.overlay ? 96 : 48;
    }

ngOnDestroy(): any {
        
    }
    

   
}